module.exports = __webpack_public_path__ + "img/img_works03.3add5bd6.jpg";